/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */

export const environment = {
    production: true,
    restUrl: 'https://sandbox.cp.yasc.de/api',
    homePage: 'cp',
    dateFormatShort: 'DD.MM.YYYY',
    dateFormat: 'DD.MM.YYYY HH:mm:ss',
    dateFormatWithFractions: 'DD.MM.YYYY HH:mm:ss.SS',
    dateFormatInternational: 'YYYY/MM/DD HH:mm:ss',
    dateFormatInternationalWithFractions: 'YYYY/MM/DD HH:mm:ss.SS',
    dateFormatInternationalShort: 'YYYY/MM/DD',
    socketHost: 'https://sandbox.cp.yasc.de/socket',
    socketLogLevel: 2, //-> {LogLevel} from '@microsoft/signalr/src/ILogger'
};

